import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";
import { LANDING } from "@/constants/testIds";

export default function FaqSection({ faqs }) {
  const { t } = usePublicLang();
  if (!faqs || faqs.length === 0) return null;

  return (
    <section id="faq" className="py-20 md:py-28 px-5 bg-white" data-testid={LANDING.faqSection}>
      <div className="max-w-2xl mx-auto">
        <ScrollReveal className="text-center mb-10 md:mb-14">
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-[#292522]">{t("landing.faq.sectionTitle")}</h2>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <Accordion type="single" collapsible>
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="border-b border-[rgba(140,125,112,0.2)]" data-testid={`${LANDING.faqItemPrefix}${f.id}`}>
                <AccordionTrigger className="font-serif text-lg md:text-xl text-left text-[#292522] hover:no-underline">{f.question}</AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed text-[#6B6058]">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  );
}
